import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CategoryColumnTitle,
  CategoryColumnTitleCont,
  CatHeadArrowCont,
  ResultsHeader,
} from './CategoriesAndTopicsTableHeader.styles';
import { getScoreSortFilters } from '../../../helpers/helpers';
import { useFilters } from '../../../hooks/useFilters';
import { useNestedSort } from '../../../hooks/useNestedSort';
import { LabelRegularBoldM } from '../../../styles/globals';
import Arrow from '@/assets/icons/filledDownArrow.svg?react';

interface ICategoriesAndTopicsTableHeader {
  isTotalsTabActive: boolean;
}

const CategoriesAndTopicsTableHeader: FC<ICategoriesAndTopicsTableHeader> = ({
  isTotalsTabActive,
}) => {
  const { currentFilters } = useFilters();
  const { key, value } = getScoreSortFilters(currentFilters, 'surveyReport', 'categorySort');
  const { manageTripleSortState } = useNestedSort(
    { score: value || null },
    'categorySort',
    'surveyReport'
  );
  const scoreStateActive = key === 'score' && value === 'asc';
  const scoreStateInActive = key === 'score' && value !== 'asc' && value !== 'desc';

  const { t } = useTranslation();
  return (
    <>
      <ResultsHeader id="ResultsHeader">
        <CategoryColumnTitleCont>
          <CategoryColumnTitle id="CategoryColumnTitle">
            {t('report.results.category')}
          </CategoryColumnTitle>
        </CategoryColumnTitleCont>
        <CatHeadArrowCont
          onClick={() => manageTripleSortState('score')}
          inActive={scoreStateInActive}
          active={scoreStateActive}
        >
          {isTotalsTabActive && (
            <>
              <LabelRegularBoldM>{t('report.results.score')}</LabelRegularBoldM>
              <Arrow data-testid="catScoreSort" />
            </>
          )}
        </CatHeadArrowCont>
      </ResultsHeader>
    </>
  );
};
export default CategoriesAndTopicsTableHeader;
